import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './components/auth/Login';
import VerifyTF from './components/VerifyTF';
import CréerVentes from './components/CréerVente';
import MesVentes from './components/MesVentes';
import AuthRoute from './routes/AuthRoute';
import PrivateRoute from './routes/PrivateRoute';

import PublicLayout from './layouts/PublicLayout';
import PrivateLayout from './layouts/PrivateLayout';
import CreerVente from './components/CreerVente';
import MontantView from './components/MontantView';
import TrConservation from './components/TrConservation';
import TrEnregistrement from './components/TrEnregistrement';
import Payer from './components/Payer';
import PayementEnregistrement from './components/PayementEnregistrement';
// import ShowVente from './components/showVente';
import SaveFile from './test/saveFile';
import QuittanceTrConservation from './components/quittance/QuittanceTrConservation';
import PaiementTrConservation from "./components/paiement/PaiementTrConservation";
import PaiementTrEnregistrement from './components/paiement/PaiementTrEnregistrement';
import QuittanceTrEnregistrement from './components/quittance/QuittanceTrEnregistrement';
import ActeVente from './components/ActeVente';
import MesHypotheques from './components/Hypotheques/MesHypotheques';
import EnregistrementVente from './components/EnregistrementVente';
import InitierHypo from './components/Hypotheques/InitierHypo';
import ShowHypo from './components/Hypotheques/ShowHypo';
import PaiementHypotheque from './components/paiement/PaiementHypotheque.js'
import ActeHypotheque from './components/Hypotheques/ActeHypotheque.js';
import ModifierMotPasse from './components/auth/ModifierMotPasse.js';
import ShowVente from './components/ShowVente.js';

function AppRoutes() {
  return (
    <Routes>

      <Route path='/saveFile' element={<SaveFile/>}/>

      {/* Public Pages - No Header */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={
          <AuthRoute>
            <Login />
          </AuthRoute>
        } />
        <Route path="/login" element={
          <AuthRoute>
            <Login />
          </AuthRoute>
        } />
      </Route>

      {/* Private Pages - With Header */}
      <Route element={<PrivateRoute><PrivateLayout /></PrivateRoute>}>
        <Route path="/verify-tf" element={<VerifyTF />} />
        <Route path="/creer-vente" element={<CréerVentes />} />
        <Route path="/mes-ventes" element={<MesVentes />} />
        <Route path="/new/vente" element={<CreerVente />} />
        <Route path="/vente/montant" element={<MontantView />} />
        <Route path="/tr/conservation/:w_id" element={<TrConservation />} />
        <Route path="/tr/conservation/payer/:w_id" element={<Payer />} />
        <Route path="/tr/enregistrement/:w_id" element={<TrEnregistrement />} />
        <Route path="/tr/enregistrement/payer/:w_id" element={<PayementEnregistrement />} />
        <Route path="/vente/details/:id_vente" element={<ShowVente/>} />

        <Route path="/vente/paiements/:w_id" element={<PaiementTrConservation/>} />
        {/* <Route path='/vente/quittance/tr/conservation/:id_quittance_tr_conservation/:w_id' element={<QuittanceTrConservation/>} /> */}
        
        <Route path="/vente/paiements/tr/enregistrement/:w_id" element={<PaiementTrEnregistrement/>} />
        {/* <Route path='/vente/quittance/tr/enregistrement/:id_quittance_tr_enregistrement/:w_id' element={<QuittanceTrEnregistrement/>} /> */}

        <Route path='/vente/acte-vente/:id_vente' element={<ActeVente/>}/>

        <Route path='/mes-hypotheques' element={<MesHypotheques/>} />
        <Route path='/enregistrement-vente' element={<EnregistrementVente/>} />

        <Route path='/hypotheque-tf' element={<InitierHypo/>} />
        <Route path='/hypotheque/show/:id_hypotheque' element={<ShowHypo/>} />

        <Route path="/hypotheque/paiements/:w_id" element={<PaiementHypotheque/>} />
        
        <Route path='/hypotheque/acte-hypotheque/:id_hypotheque' element={<ActeHypotheque/>}/>

        <Route path='/modifier/mot/passe' element={<ModifierMotPasse/>} />



      </Route>

      {/* Redirect everything else */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;







